import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

const Loader = ({
  color = "#3f51b5",
  size = 50,
  loading = true,
  style,
  text,
  overlay = false,
}) => {
  return (
    loading && (
      <div
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: overlay && "rgba(255, 255, 255, 0.5)",
          ...style,
        }}
      >
        {loading && text && <p>{text}</p>}
        <ClipLoader
          color={color}
          loading={loading}
          aria-label="Loading Spinner"
          data-testid="loader"
          size={size}
        />
      </div>
    )
  );
};

export default Loader;
